import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://45.170.26.9:8004',
});

// Tenant da URL (/:cnpj/:filial/...), definido pelo ValidaEmpresa.
// A API resolve o banco pelo CNPJ (X-Client-ID) + filial (X-Filial-NAME).
let tenant: { cnpj: string; filial: string } | null = null;

export function definirTenant(cnpj: string, filial: string) {
  tenant = { cnpj: cnpj.replace(/\D/g, ''), filial };
}

api.interceptors.request.use(
  (config) => {
    if (tenant) {
      config.headers['X-Client-ID'] = tenant.cnpj;
      config.headers['X-Filial-NAME'] = tenant.filial;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
